import { apiClient } from '../client';
import type {
  AuthTokenRequest,
  AuthTokenResponse,
  Check2FARequest,
  Check2FAResponse,
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  RequestResetPasswordRequest,
  RequestResetPasswordResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  VerifyRequest,
  VerifyResponse,
} from '@/types/api';

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>('/user/login', data).then((r) => r.data),

  check2fa: (data: Check2FARequest) =>
    apiClient.post<Check2FAResponse>('/user/check2fa', data).then((r) => r.data),

  authToken: (data: AuthTokenRequest) =>
    apiClient.post<AuthTokenResponse>('/user/authToken', data).then((r) => r.data),

  register: (data: RegisterRequest) =>
    apiClient.post<RegisterResponse>('/user/register', data).then((r) => r.data),

  requestResetPassword: (data: RequestResetPasswordRequest) =>
    apiClient
      .post<RequestResetPasswordResponse>('/user/requestResetPassword', data)
      .then((r) => r.data),

  // PATH-id-параметры (token + hash) идут в URL, а не в body. По нашему
  // HMAC-механизму они автоматически попадают в подпись через нормализацию
  // path в sign.ts (см. backend-compat.md #3 про PATH-ID first).
  resetPassword: (token: string, hash: string, data: ResetPasswordRequest) =>
    apiClient
      .post<ResetPasswordResponse>(`/user/resetPassword/${token}/${hash}`, data)
      .then((r) => r.data),

  // POST /user/verify — подтверждение email после регистрации. token + hash
  // приходят в query email-письма. На success возвращает auth_key — фактически
  // логинит юзера.
  verify: (data: VerifyRequest) =>
    apiClient.post<VerifyResponse>('/user/verify', data).then((r) => r.data),
};
